function getTitle(array, value, key = 'slug') {
    let results = [];
    for (const i in array) {
        if (!Object.prototype.hasOwnProperty.call(array, i)) {
            continue;
        }

        if (typeof array[i] === 'object') {
            results = results.concat(getTitle(array[i], value));
        }

        if (typeof array[i] !== 'object') {
            if ((i === key && array[i] === value) || (i === key && value === '')) {
                results.push(array);
            }
        }
    }

    return results;
}

export default function({currentRoute, menu}) {
    let fullPath = currentRoute.fullPath.replace('/[^a-z0-9 - /]/', '');

    if (fullPath.includes('?')) {
        [fullPath] = fullPath.split('?');
    }

    const params = fullPath.substring(1).split('/');
    const crumbs = [];
    let path = '';

    params.forEach((param, index, {length}) => {
        path = `${path}/${param}`;

        const title = getTitle(menu, param)[0]?.title ?? '';

        if (index === length - 1) {
            crumbs.push({
                slug: param,
                title,
                disabled: true,
            });
        } else {
            crumbs.push({
                slug: param,
                title,
                disabled: false,
                href: param !== 'for-individuals' ? path : '/',
            });
        }
    });

    return crumbs;
};
